var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fh-container',[_c('fh-crud-establecimientos',{attrs:{"formTitle":_vm.title},on:{"terminated":_vm.checkEstablecimientoSet}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }